import React from 'react';
import UmangUtsavBanner from './UmangUtsavBanner';

const BANNER_TEMPLATES = {
    UMANG_UTSAV: UmangUtsavBanner,
};

export const BannerTemplateRenderer = ({ slide }) => {
    const Template = BANNER_TEMPLATES[slide?.type];
    if (!Template) return null;
    return <Template {...slide} />;
};
